<div class="bg-color-181818 flex-row column align-center ptb-24 pb-md-0 row-gap-32 row-gap-md-24 height-100-pr">
    <div class="flex-row align-center content-between full">
        <h2 class="color-EFEFEF fs-24 fs-md-18 fw-7 full text-center ml-md-24 text-left-md">Broker Login</h2>
        <button type="button" class="tw-bg-transparent tw-border-0 tw-p-0" aria-label="Close" (click)="closeDialog()">
            <x-icon iconColor="#9DA6BF" width="20px" height="20px" class="cursor-pointer mr-24"
                aria-hidden="true"></x-icon></button>
    </div>
    <div class="banner position-relative ptb-md-0 width-43 overflow-hidden width-md-31 d-flex-md content-center-md">
        <img src="assets/trading/exclamation.svg" alt="exclamation" class="position-absolute width-24-pr height-100-pr"
            style="left: -28px;">
        <p class="fs-12 color-9DA6BF mr-38 mr-md-0 ptb-22 text-right width-md-19 lh-md-18 text-left-md ptb-md-13">
            Certain brokers will have delayed feed after login.</p>
    </div>
    <div
        class="mt-16 mt-md-0 flex-row column max-height-35 max-height-md-42 overflow-hidden overflow-y width-43 full-md mb-9 mb-md-0">
        <ng-container *ngIf="!isBrokerLoading">
            <ng-container *ngFor="let brokrage of brokrageList;let i=index">
                <div
                    class="border-color-2D2D39 ptb-13 plr-28 plr-md-24 flex-row align-center content-between border-bottom-none-md">
                    <div class="flex-row align-center column-gap-34">
                        <div class="bg-white border-radius-circle flex-row align-center content-center width-48-px height-48-px width-md-4 height-md-4"
                            *ngIf="brokrage.code=='zerodha'">
                            <img src="assets/new-assets/partner/zerodha.png" class="max-width-3" [alt]="brokrage.code">
                        </div>
                        <div class="bg-white border-radius-circle flex-row align-center content-center width-48-px height-48-px width-md-4 height-md-4"
                            *ngIf="brokrage.code=='five_paisa'">
                            <img src="assets/new-images/5paisa.png" class="max-width-3" [alt]="brokrage.code">
                        </div>
                        <div class="bg-white border-radius-circle flex-row align-center content-center width-48-px height-48-px width-md-4 height-md-4"
                            *ngIf="brokrage.code=='nuvama'">
                            <img src="assets/new-assets/partner/nuvama.png" class="max-width-4" [alt]="brokrage.code">
                        </div>
                        <div class="bg-white border-radius-circle flex-row align-center content-center width-48-px height-48-px width-md-4 height-md-4"
                            *ngIf="brokrage.code=='aditya_birla'">
                            <img src="assets/new-assets/partner/aditya-birla.svg" class="max-width-3 max-width-md-28-px"
                                [alt]="brokrage.code">
                        </div>
                        <div class="bg-white border-radius-circle flex-row align-center content-center width-48-px height-48-px width-md-4 height-md-4 overflow-hidden"
                            *ngIf="brokrage.code=='bajaj_finserv'">
                            <img src="assets/new-assets/partner/bajaj-finance.png" [alt]="brokrage.code">
                        </div>
                        <div class="bg-white border-radius-circle flex-row align-center content-center width-48-px height-48-px width-md-4 height-md-4"
                            *ngIf="brokrage.code=='angel_broking'">
                            <img src="assets/new-assets/partner/angel-broking.png" class="max-width-25-px"
                                [alt]="brokrage.code">
                        </div>
                        <div class="bg-white border-radius-circle flex-row align-center content-center width-48-px height-48-px width-md-4 height-md-4"
                            *ngIf="brokrage.code=='alice_blue'">
                            <img src="assets/new-assets/partner/alice-blue.svg" class="max-width-3"
                                [alt]="brokrage.code">
                        </div>
                        <div class="bg-white border-radius-circle flex-row align-center content-center width-48-px height-48-px width-md-4 height-md-4"
                            *ngIf="brokrage.code=='klever_trade'">
                            <img src="assets/new-assets/partner/klever-trade.png" class="max-width-3"
                                [alt]="brokrage.code">
                        </div>
                        <div class="bg-white border-radius-circle flex-row align-center content-center width-48-px height-48-px width-md-4 height-md-4"
                            *ngIf="brokrage.code=='master_trust'">
                            <img src="assets/new-assets/partner/master-trust.png" class="max-width-3"
                                [alt]="brokrage.code">
                        </div>
                        <div class="bg-white border-radius-circle flex-row align-center content-center width-48-px height-48-px width-md-4 height-md-4"
                            *ngIf="brokrage.code=='trade_smart'">
                            <img src="assets/new-assets/partner/trade-smart.png" class="max-width-3 max-width-md-25-px"
                                [alt]="brokrage.code">
                        </div>
                        <div class="bg-white border-radius-circle flex-row align-center content-center width-48-px height-48-px width-md-4 height-md-4"
                            *ngIf="brokrage.code=='ZEBU'">
                            <img src="assets/new-assets/partner/zebu.png" class="max-width-3" [alt]="brokrage.code">
                        </div>
                        <div class="bg-white border-radius-circle flex-row align-center content-center width-48-px height-48-px width-md-4 height-md-4"
                            *ngIf="brokrage.code=='finvasia'">
                            <img src="assets/new-assets/partner/finvasia-shoonya.jpg" class="max-width-4 max-width-md-3"
                                [alt]="brokrage.code">
                        </div>
                        <div class="bg-white border-radius-circle flex-row align-center content-center width-48-px height-48-px width-md-4 height-md-4"
                            *ngIf="brokrage.code=='upstox'">
                            <img src="assets/icons/upstox.svg" class="max-width-4 max-width-md-3" [alt]="brokrage.code">
                        </div>
                        <div class="bg-white border-radius-circle flex-row align-center content-center width-48-px height-48-px width-md-4 height-md-4"
                            *ngIf="brokrage.code=='paytm'">
                            <img src="assets/brokerage/paytm.png" class="max-width-4 max-width-md-3"
                                [alt]="brokrage.code">
                        </div>
                        <div class="flex-row column row-gap-10">
                            <p class="color-EFEFEF">{{brokrage.name}}</p>
                            <div class=" fs-12 plr-10 ptb-3 width-max"
                                [class]="(liveFeedData | brokerLiveFeed: brokrage.code) ?'bg-color-240505 color-E74141':'bg-color-0C280B color-52D14C'">
                                {{(liveFeedData | brokerLiveFeed: brokrage.code) ? 'Delayed feed': 'Live feed'}}</div>
                        </div>
                        <div class="bg-white border-radius-circle flex-row align-center content-center width-48-px height-48-px width-md-4 height-md-4"
                            *ngIf="brokrage.code=='ventura'">
                            <img src="assets/brokerage/ventura.jpeg" class="max-width-3 max-width-md-2"
                                [alt]="brokrage.code">
                        </div>
                    </div>
                    <button type="button" [disabled]="isBrokerLoading" class="bg-none" (click)="selectBroker(brokrage)">
                        <img src="assets/trading/right-arrow-circle.svg" alt="Select broker"
                            class="max-width-4 cursor-pointer">
                    </button>
                </div>
            </ng-container>
        </ng-container>
        <ng-container *ngIf="isBrokerLoading">
            <app-loader></app-loader>
        </ng-container>
    </div>
</div>